/**
 * Última lectura conocida de un sensor.
 *
 * Los sensores digitales llegan como 0/1 y los analógicos como número decimal;
 * esta clase unifica ambos y sabe presentarse al usuario.
 */
export class Lectura {
  constructor(
    readonly valor: number,
    readonly timestamp: Date | null,
  ) {}

  /** Devuelve `null` cuando el sensor nunca ha reportado o el valor no es numérico. */
  static crear(
    valorCrudo: unknown,
    timestampCrudo: string | Date | null | undefined,
  ): Lectura | null {
    if (valorCrudo === null || valorCrudo === undefined || valorCrudo === '') return null;

    const valor = typeof valorCrudo === 'boolean' ? Number(valorCrudo) : Number(valorCrudo);
    if (!Number.isFinite(valor)) return null;

    let timestamp: Date | null = null;
    if (timestampCrudo) {
      const fecha = timestampCrudo instanceof Date ? timestampCrudo : new Date(timestampCrudo);
      timestamp = Number.isNaN(fecha.getTime()) ? null : fecha;
    }

    return new Lectura(valor, timestamp);
  }

  get esEncendido(): boolean {
    return this.valor !== 0;
  }

  /** Antigüedad de la lectura en segundos, o `null` si no tiene marca de tiempo. */
  antiguedadSegundos(ahora: Date = new Date()): number | null {
    if (!this.timestamp) return null;
    return Math.max(0, (ahora.getTime() - this.timestamp.getTime()) / 1000);
  }

  /**
   * Texto del valor listo para mostrar.
   * `decimales` se toma de la configuración del tipo de sensor.
   */
  formatear(decimales = 2): string {
    return Number.isInteger(this.valor) ? String(this.valor) : this.valor.toFixed(decimales);
  }
}
